import React, { useState, useEffect } from 'react';
import Sidebar from '../../components/Sidebar';
import '../CompanyHistory.css';

const Products = () => {
  const [activeSection, setActiveSection] = useState('heat-exchanger');
  
  const sidebarItems = [
    { name: 'Plate Heat Exchanger', path: 'heat-exchanger' },
    { name: 'Compact Equipment Unit', path: 'compact-unit' },
    { name: 'Instant Hot Water Heater', path: 'heating-system' },
    { name: 'Brazing Heat Exchanger', path: 'brazing-heat-exchanger' },
    { name: 'Spiral Heat Exchanger', path: 'spiral-heat-exchanger' },
    { name: 'Welded Plate Heat Exchanger', path: 'welded-plate-heat-exchanger' },
    { name: 'GAS COOLER', path: 'gas-cooler' },
    { name: 'Closed Expansion Tank', path: 'closed-expansion-tank' },
    { name: 'Expansion Separator', path: 'expansion-separator' },
    { name: 'Plate Coil', path: 'plate-coil' },
    { name: 'Spherical Tank', path: 'ball-tank' },
    { name: 'ATM Tank', path: 'atm-tank' }
  ];

  // 스크롤 스파이 기능
  useEffect(() => {
    const handleScroll = () => {
      const sections = sidebarItems.map(item => item.path);
      
      for (let i = sections.length - 1; i >= 0; i--) {
        const section = document.getElementById(sections[i]);
        if (section && section.offsetTop - 200 <= window.scrollY) {
          setActiveSection(sections[i]);
          break;
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // 해시 URL 처리 (페이지 로드 시 해당 섹션으로 이동)
  useEffect(() => {
    const hash = window.location.hash.replace('#', '');
    if (hash) {
      setTimeout(() => {
        scrollToSection(hash);
      }, 50);
    }
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'auto' });
    }
  };

  return (
    <>
      <Sidebar 
        category="Products" 
        items={sidebarItems} 
        activeSection={activeSection}
        onItemClick={scrollToSection}
      />
      <div className="company-history-page">
        <div className="history-container">
          <h1 className="page-category-title">Products</h1>
          
          {/* Plate Heat Exchanger Section */}
          <section id="heat-exchanger" className="section">
            <h2 className="section-title">Plate Heat Exchanger</h2>
            
            {/* Product Overview */}
            <div className="product-description">
              <h3>Plate Heat Exchanger</h3>
              <p>Plate heat exchangers consist of main components such as heat plates, gaskets, frames, and tightening bolts. Among these, heat plates create strong turbulence to achieve high heat exchange performance, <br/>while gaskets form the flow paths for primary and secondary fluids and serve as sealing components.</p>
            </div>

            {/* Plate Heat Exchanger Image */}
            <div className="esg-grid">
              <div className="esg-item">
                <img src="/products/panhyung.jpg" alt="Plate Heat Exchanger" className="esg-image" />
                <h3 className="esg-title">Plate Heat Exchanger</h3>
              </div>
            </div>

            {/* Advantages */}
            <div className="product-features">
              <h3>▶ Advantages - Advantage</h3>
              <div className="features-text-list">
                <div className="features-column">
                  <div className="feature-text-item">• Excellent heat transfer effect (High Efficiency)</div>
                  <div className="feature-text-item">• Compact structure (Compact)</div>
                  <div className="feature-text-item">• Fully dismountable assembly (Easy Maintenance)</div>
                </div>
                <div className="features-column">
                  <div className="feature-text-item">• Various flow path configurations (Versatility of Duty)</div>
                  <div className="feature-text-item">• Economical installation cost (Economical in Cost)</div>
                  <div className="feature-text-item">• Easy capacity expansion and modification (Capacity Adaptability)</div>
                </div>
              </div>
            </div>

            {/* Standard Specifications */}
            <div className="product-specs">
              <h3>▶ Specifications - Standard Specification</h3>
              <div className="specs-text-list">
                  <div className="spec-text-item">• Plate Material : SS304, SS316, SS316L, ASTM-A240M-316L, SMO254, SLX904<br/>        Titanium, Titanium-Palladium, Nickel, Nickel Alloy<br/>        Hastelloy-C, Hastelloy-B, Etc.</div>
                <div className="spec-text-item">• Gasket Material : NBR, EPDM, HNBR, Viton, Teflon, Silicon</div>
                <div className="spec-text-item">• Max. Design Pressure : 34kg/cm²</div>
                <div className="spec-text-item">• Max. Design Temperature : -30°C ~ 210°C</div>
              </div>
            </div>

            {/* Applications */}
            <div className="product-applications">
              <h3>▶ Applications - Application</h3>
              <div className="applications-text-list">
                <div className="application-text-item">- HVAC (Heating, Ventilation, Air Conditioning)</div>
                <div className="application-text-item">- Sterilization processes for food and pharmaceuticals (HTST & UHT)</div>
                <div className="application-text-item">- Heat recovery systems (Heat Recovery System)</div>
                <div className="application-text-item">- Metal industry (Iron & Steel Industry)</div>
                <div className="application-text-item">- Chemical industry (Chemical Industry)</div>
                <div className="application-text-item">- Central cooling facilities using seawater and river water (Central Cooling with Sea Water)</div>
                <div className="application-text-item">- Shipbuilding industry (Shipbuilding Industry)</div>
                <div className="application-text-item">- High-efficiency evaporators and condensers for chillers and heat pumps (Evaporator & Condenser in Chiller and Heat Pump)</div>
              </div>
            </div>

            {/* Product Specifications Image */}
            <div className="esg-grid">
              <div className="esg-item">
                <img src="/products/panhyung_kyukyuk.jpg" alt="Plate Heat Exchanger Product Specifications" className="esg-image" />
                <h3 className="esg-title">Plate Heat Exchanger Product Specifications</h3>
              </div>
            </div>

            {/* Specifications Table */}
            <div className="esg-grid">
              <div className="esg-item">
                <img src="/products/panhyung_sayang.png" alt="Plate Heat Exchanger Specification Table" className="esg-image" />
                <h3 className="esg-title">Plate Heat Exchanger Specification Table</h3>
              </div>
            </div>
          </section>

          {/* Compact Equipment Unit Section */}
          <section id="compact-unit" className="section">
            <h2 className="section-title">Compact Equipment Unit</h2>
            
            {/* Product Overview */}
            <div className="product-description">
              <h3>Compact Equipment Unit</h3>
              <p>District heating compact equipment units are standardized modules designed by heat exchanger manufacturers for equipment installed in district heating sub-stations, including plate heat exchangers, pumps, temperature control valves, and automatic controls. After obtaining approval from the client and district heating company, the manufacturer performs equipment manufacturing, procurement, piping construction, and inspection comprehensively at the factory, and the product is installed in the district heating user's mechanical room.</p>
            </div>

            {/* System Configuration Diagram */}
            <div className="esg-grid">
              <div className="esg-item">
                <img src="/products/compact.gif" alt="Compact Equipment Unit System Configuration" className="esg-image" />
                <h3 className="esg-title">Compact Equipment Unit System Configuration</h3>
              </div>
            </div>

            {/* Advantages */}
            <div className="product-features">
              <h3>▶ Advantages - Advantage</h3>
              <div className="features-text-list">
                <div className="features-column">
                  <div className="feature-text-item">• Multi Benefit System (MBS) Structure</div>
                  <div className="feature-text-item">  - Piping structure of separation type recommended by Korea District Heating Corporation</div>
                  <div className="feature-text-item">  - Advanced hybrid type with integrated installation space and separated maintenance, realizing the most compact piping layout.</div>
                  <div className="feature-text-item">  - Increases mechanical room utilization.</div>
                </div>
                <div className="features-column">
                  <div className="feature-text-item">• High Quality Plate Heat Exchanger</div>
                  <div className="feature-text-item">  - World-class heat transfer plates capable of operating even at maximum pressure of 34bar</div>
                  <div className="feature-text-item">  - Easy-Hook gasket adoption for easy cleaning and maintenance (International patent acquired: Korea, Japan, USA, Sweden, China, etc.)</div>
                </div>
                <div className="features-column">
                  <div className="feature-text-item">• Perfect Quality Assurance System</div>
                  <div className="feature-text-item">  - Strict quality management is conducted from design, manufacturing, inspection, delivery to commissioning based on ISO9001 quality certification system.</div>
                  <div className="feature-text-item">  - Process-by-process inspection is performed by the design team and QA team at our factory.</div>
                  <div className="feature-text-item">  - 24-hour A/S system established</div>
                </div>
              </div>
            </div>

            {/* Applications */}
            <div className="product-applications">
              <h3>▶ Applications - Application</h3>
              <div className="applications-text-list">
                <div className="application-text-item">- All apartments, commercial buildings, and public buildings using medium temperature water from district heating companies as heat source for heating and hot water supply</div>
              </div>
            </div>

            {/* Principal Customers */}
            <div className="product-partners">
              <h3>▶ Principal Customers - Principal Customer</h3>
              <div className="partners-text-list">
                <div className="partner-text-item">- Major Tier 1 construction companies including Hyundai Construction, Hyundai Industrial Development, Daelim Industrial, Lotte Construction, Korea Land & Housing Corporation, GS Construction, Seoul Metropolitan Government Urban Development Corporation, Hana Construction, Byucksan Construction, Doosan Construction, Ssangyong Construction, Namkwang Construction, Hanwha Construction, SK Construction, etc.</div>
              </div>
            </div>
          </section>

          {/* Instant Hot Water Heater Section */}
          <section id="heating-system" className="section">
            <h2 className="section-title">Instant Hot Water Heater</h2>
            
            {/* Product Overview */}
            <div className="product-description">
              <h3>Instant Hot Water Heater</h3>
              <p>Instant hot water heaters are products that use steam as a heat source to supply hot water or heating water to systems. They are standardized modules designed with plate heat exchangers, temperature control valves, steam traps, automatic controls, etc., and are installed in user mechanical rooms after comprehensive equipment procurement, manufacturing, piping, and inspection at the factory.</p>
            </div>

            {/* Product Image */}
            <div className="esg-grid">
              <div className="esg-item">
                <img src="/products/product_03.gif" alt="Instant Hot Water Heater" className="esg-image" />
                <h3 className="esg-title">Instant Hot Water Heater</h3>
              </div>
            </div>

            {/* Advantages */}
            <div className="product-features">
              <h3>▶ Advantages - Advantage</h3>
              <div className="features-text-list">
                <div className="features-column">
                  <div className="feature-text-item">• Product modularization and standardization</div>
                  <div className="feature-text-item">  - Modularized manufacturing products reduce construction period and minimize interference with other processes</div>
                  <div className="feature-text-item">  - Quality improvement through design and construction with standardized and verified modules</div>
                  <div className="feature-text-item">  - Construction cost reduction through installation space reduction</div>
                </div>
                <div className="features-column">
                  <div className="feature-text-item">• High Quality Plate Heat Exchanger</div>
                  <div className="feature-text-item">  - World-class heat transfer plates capable of operating even at maximum pressure of 34bar</div>
                  <div className="feature-text-item">  - Easy-Hook gasket adoption for easy cleaning and maintenance (International patent acquired: Korea, Japan, USA, Sweden, China, etc.)</div>
                </div>
                <div className="features-column">
                  <div className="feature-text-item">• Perfect Quality Assurance System</div>
                  <div className="feature-text-item">  - Strict quality management is conducted from design, manufacturing, inspection, delivery to commissioning based on ISO9001 quality certification system.</div>
                  <div className="feature-text-item">  - Process-by-process inspection is performed by the design team and QA team at our factory.</div>
                  <div className="feature-text-item">  - 24-hour A/S system established</div>
                </div>
                <div className="features-column">
                  <div className="feature-text-item">• Automatic control, MCC, circulation pump and shut-off valve included</div>
                </div>
              </div>
            </div>

            {/* Applications */}
            <div className="product-applications">
              <h3>▶ Applications - Application</h3>
              <div className="applications-text-list">
                <div className="application-text-item">- All apartments, commercial buildings, and public buildings using steam as heat source for heating and hot water supply</div>
              </div>
            </div>

            {/* Principal Customers */}
            <div className="product-partners">
              <h3>▶ Principal Customers - Principal Customer</h3>
              <div className="partners-text-list">
                <div className="partner-text-item">- Major Tier 1 construction companies including Hyundai Construction, GS Construction, Hyundai Industrial Development, Daelim Industrial, Korea Land & Housing Corporation, SH Corporation, etc.</div>
              </div>
            </div>
          </section>

          {/* Brazing Heat Exchanger Section */}
          <section id="brazing-heat-exchanger" className="section">
            <h2 className="section-title">Brazing Heat Exchanger</h2>
            
            {/* Product Overview */}
            <div className="product-description">
              <h3>Brazing Heat Exchanger</h3>
              <p>Brazing Plate Heat Exchanger is one of the most compact forms of heat exchangers among the heat exchangers developed so far. The heat transfer principle of this heat exchanger is the same as that of plate heat exchangers, but sealing and fluid distribution are products that introduce Copper & Nickel welding technology instead of the gasket role in plate heat exchangers.</p>
            </div>

            {/* Product Image */}
            <div className="esg-grid">
              <div className="esg-item">
                <img src="/products/product_04.gif" alt="Brazing Heat Exchanger" className="esg-image" />
                <h3 className="esg-title">Brazing Heat Exchanger</h3>
              </div>
            </div>

            {/* Advantages */}
            <div className="product-features">
              <h3>▶ Advantages - Advantage</h3>
              <div className="features-text-list">
                <div className="features-column">
                  <div className="feature-text-item">• Ultra-compact (Compact)</div>
                  <div className="feature-text-item">• High efficiency (High Heat Transfer performance)</div>
                  <div className="feature-text-item">• Economical (Economical in Cost)</div>
                </div>
              </div>
            </div>

            {/* Specifications */}
            <div className="product-specs">
              <h3>▶ Specifications - Standard Specification</h3>
              <div className="specs-text-list">
                <div className="spec-text-item">• Plate Material : Stainless Steel, Nickel</div>
                <div className="spec-text-item">• Cover Plate and Connections : Stainless Steel, Nickel</div>
                <div className="spec-text-item">• Brazing Materials : 99.9% Copper, Nickel</div>
                <div className="spec-text-item">• Design Pressure : 30kg/cm² (Vacuum)</div>
                <div className="spec-text-item">• Test Pressure : 40kg/cm²</div>
                <div className="spec-text-item">• Temperature : -195°C ~ 225°C</div>
              </div>
            </div>

            {/* Applications */}
            <div className="product-applications">
              <h3>▶ Applications - Application</h3>
              <div className="applications-text-list">
                <div className="application-text-item">
                  <span className="application-category-title">HVAC</span>
                  <ul className="sub-list">
                    <li>Evaporators and Condensers in Chillers and Heat Pumps</li>
                    <li>Heating Floors and Hot Water Tapping in District Heating System</li>
                    <li>Fluid Isolation of Solar Energy System</li>
                    <li>Hot Water Generators in Steam Application</li>
                  </ul>
                </div>
                <div className="application-text-item">
                  <span className="application-category-title">General Industrial Application</span>
                  <ul className="sub-list">
                    <li>Oil Cooling of Hydraulic System</li>
                    <li>Water Cooling of Molding machines, Induction Furances and Plastic Injection Machines</li>
                    <li>Heat Recovery System</li>
                    <li>Heating and Cooling in Food Processing Industries</li>
                  </ul>
                </div>
              </div>
            </div>
          </section>

          {/* Spiral Heat Exchanger Section */}
          <section id="spiral-heat-exchanger" className="section">
            <h2 className="section-title">Spiral Heat Exchanger</h2>
            
            {/* Product Overview */}
            <div className="product-description">
              <h3>Spiral Heat Exchanger</h3>
              <p>Spiral heat exchangers are also called vortex or spiral heat exchangers, and are products composed of covers, plain plates, pins, etc. They are suitable for heat exchange processes with relatively high viscosity fluids, fluids with high scale formation, and large thermal length.</p>
            </div>

            {/* Product Image */}
            <div className="esg-grid">
              <div className="esg-item">
                <img src="/products/product_06.gif" alt="Spiral Heat Exchanger" className="esg-image" />
                <h3 className="esg-title">Spiral Heat Exchanger</h3>
              </div>
            </div>

            {/* Advantages */}
            <div className="product-features">
              <h3>▶ Advantages - Advantage</h3>
              <div className="features-text-list">
                <div className="features-column">
                  <div className="feature-text-item">• Suitable for relatively high temperature and pressure (Relatively High Design Pressure & Temperature)</div>
                  <div className="feature-text-item">• Excellent heat transfer effect (High Efficiency)</div>
                </div>
                <div className="features-column">
                  <div className="feature-text-item">• Excellent self-cleaning effect (Easy Maintenance)</div>
                  <div className="feature-text-item">• Applicable to high viscosity and high-fouled fluids (Application on High Viscosity & High-Fouled Liquid)</div>
                </div>
              </div>
            </div>

            {/* Standard Specifications */}
            <div className="product-specs">
              <h3>▶ Specifications - Standard Specification</h3>
              <div className="specs-text-list">
                <div className="spec-text-item">• Max. Operating Design Pressure : 20kg/cm²</div>
                <div className="spec-text-item">• Max. Operating Temperature : 350°C ~ 400°C</div>
                <div className="spec-text-item">• Area : 0.5 ~ 300m²</div>
                <div className="spec-text-item">• Material : Carbon steel, stainless steel, nickel alloy, titanium, etc.</div>
              </div>
            </div>

            {/* Applications */}
            <div className="product-applications">
              <h3>▶ Applications - Application</h3>
              <div className="applications-text-list">
                <div className="application-text-item">- Condenser & Evaporater (Gas to Air, Liquid to Liquid)</div>
                <div className="application-text-item">- Cooler & Heater (Liquid to Liquid, Liquid to Air)</div>
                <div className="application-text-item">- Heat Recovery System</div>
              </div>
            </div>
          </section>

          {/* Welded Plate Heat Exchanger Section */}
          <section id="welded-plate-heat-exchanger" className="section">
            <h2 className="section-title">Welded Plate Heat Exchanger</h2>
            
            {/* Product Overview */}
            <div className="product-description">
              <h3>Welded Plate Heat Exchanger</h3>
              <p>Welded plate heat exchangers combine the advantages of plate heat exchangers and shell & tube heat exchangers. They are advantageous for high temperature and pressure, and exhibit the same effect as shell & tube heat exchangers at 1/3~1/5 the size.</p>
            </div>

            {/* Product Images */}
            <div className="welded-heat-exchanger-slider" style={{display: 'flex', gap: '25px', marginBottom: '30px', justifyContent: 'center', maxWidth: '1014px', margin: '0 auto 30px auto', overflow: 'hidden', position: 'relative'}}>
              <div className="slider-container" style={{display: 'flex', transition: 'transform 0.5s ease-in-out', width: '100%'}}>
                <img src="/products/product_11-2.jpg" alt="Welded Plate Heat Exchanger Structure" style={{maxHeight: '338px', maxWidth: '468px', minWidth: '100%', flex: '1'}} />
                <img src="/products/product_11.jpg" alt="Welded Plate Heat Exchanger" style={{maxHeight: '338px', maxWidth: '468px', minWidth: '100%', flex: '1'}} />
              </div>
              <button className="slider-prev" style={{position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', background: 'rgba(0,0,0,0.5)', color: 'white', border: 'none', padding: '10px', borderRadius: '50%', cursor: 'pointer', zIndex: 2}} onClick={() => {
                const container = document.querySelector('.welded-heat-exchanger-slider .slider-container');
                const currentTransform = container.style.transform || 'translateX(0%)';
                if (currentTransform === 'translateX(-100%)') {
                  container.style.transform = 'translateX(0%)';
                } else {
                  container.style.transform = 'translateX(-100%)';
                }
              }}>‹</button>
              <button className="slider-next" style={{position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)', background: 'rgba(0,0,0,0.5)', color: 'white', border: 'none', padding: '10px', borderRadius: '50%', cursor: 'pointer', zIndex: 2}} onClick={() => {
                const container = document.querySelector('.welded-heat-exchanger-slider .slider-container');
                const currentTransform = container.style.transform || 'translateX(0%)';
                if (currentTransform === 'translateX(0%)') {
                  container.style.transform = 'translateX(-100%)';
                } else {
                  container.style.transform = 'translateX(0%)';
                }
              }}>›</button>
            </div>

            {/* Advantages */}
            <div className="product-features">
              <h3>▶ Advantages - Advantage</h3>
              <div className="features-text-list">
                <div className="features-column">
                  <div className="feature-text-item">• Suitable for high temperature and pressure (Relatively High Design Pressure & Temperature)</div>
                  <div className="feature-text-item">• Excellent heat transfer effect (High Efficiency)</div>
                  <div className="feature-text-item">• Reduced installation space (Low Installation Space)</div>
                </div>
                <div className="features-column">
                  <div className="feature-text-item">• Excellent self-cleaning effect (Easy Maintenance)</div>
                  <div className="feature-text-item">• Available in open and welded types for different applications, and economical maintenance possible without heat transfer plate gaskets</div>
                </div>
              </div>
            </div>

            {/* Standard Specifications */}
            <div className="product-specs">
              <h3>▶ Specifications - Standard Specification</h3>
              <div className="specs-text-list">
                <div className="spec-text-item">• Max. Operating Design Pressure : 150Bar(g)</div>
                <div className="spec-text-item">• Max. Operating Temperature : -200°C ~ 500°C</div>
                <div className="spec-text-item">• Area : 0.5 ~ 300m²</div>
                <div className="spec-text-item">• Material : Stainless steel, nickel alloy, titanium, etc.</div>
              </div>
            </div>

            {/* Applications */}
            <div className="product-applications">
              <h3>▶ Applications - Application</h3>
              <div className="applications-text-list">
                <div className="application-text-item">- Condenser & Evaporater (Gas to Air, Liquid to Liquid)</div>
                <div className="application-text-item">- Cooler & Heater (Liquid to Liquid, Liquid to Air)</div>
                <div className="application-text-item">- Heat Recovery System</div>
              </div>
            </div>
          </section>

          {/* GAS COOLER Section */}
          <section id="gas-cooler" className="section">
            <h2 className="section-title">GAS COOLER</h2>
            
            {/* Product Overview */}
            <div className="product-description">
              <h3>GROOVE TYPE FINTUBE Heat Exchanger</h3>
              <p>GROOVE TYPE FINTUBE heat exchangers are the most advantageous type for heat exchange between gas and liquid phases, exhibiting 3~5 times the effect compared to bare tubes.</p>
            </div>

            {/* Product Image */}
            <div className="esg-grid">
              <div className="esg-item">
                <img src="/products/product_10.png" alt="GROOVE TYPE FINTUBE Heat Exchanger" className="esg-image" />
                <h3 className="esg-title">GROOVE TYPE FINTUBE Heat Exchanger</h3>
              </div>
            </div>

            {/* Advantages */}
            <div className="product-features">
              <h3>▶ Advantages - Advantage</h3>
              <div className="features-text-list">
                <div className="features-column">
                  <div className="feature-text-item">• Structure suitable for high temperature GAS(AIR) with smooth expansion, advantageous for damage due to temperature expansion</div>
                  <div className="feature-text-item">• GROOVE TYPE FINTUBE is applicable at temperatures above 150°C and below 500°C</div>
                </div>
                <div className="features-column">
                  <div className="feature-text-item">• Front and rear case separation possible for economical maintenance</div>
                </div>
              </div>
            </div>

            {/* Standard Specifications */}
            <div className="product-specs">
              <h3>▶ Specifications - Standard Specification</h3>
              <div className="specs-text-list">
                <div className="spec-text-item">• Max. Operating Design Pressure : Tube Side 50Bar(g)</div>
                <div className="spec-text-item">• Max. Operating Temperature : -50°C ~ 500°C</div>
                <div className="spec-text-item">• Area : 2 ~ 500m²</div>
              </div>
            </div>

            {/* Applications */}
            <div className="product-applications">
              <h3>▶ Applications - Application</h3>
              <div className="applications-text-list">
                <div className="application-text-item">- Condenser & Evaporater (Gas to Liquid)</div>
                <div className="application-text-item">- Cooler & Heater (Gas to Liquid)</div>
                <div className="application-text-item">- Heat Recovery System</div>
              </div>
            </div>
          </section>

          {/* Closed Expansion Tank Section */}
          <section id="closed-expansion-tank" className="section">
            <h2 className="section-title">Closed Expansion Tank</h2>
            
            {/* Product Overview */}
            <div className="product-description">
              <h3>Closed Expansion Tank</h3>
              <p>Closed expansion tanks are composed of existing bladder-type expansion tanks, air compression, electronic valves, and automatic control panels. They were developed to improve the problems of reduced piping life due to pressure fluctuations during system operation and reduced expansion tank efficiency due to high pressure when using existing bladder-type expansion tanks.</p>
            </div>

            {/* Product Image */}
            <div className="esg-grid">
              <div className="esg-item">
                <img src="/products/product_07.gif" alt="Closed Expansion Tank" className="esg-image" />
                <h3 className="esg-title">Closed Expansion Tank</h3>
              </div>
            </div>

            {/* Advantages */}
            <div className="product-features">
              <h3>▶ Advantages - Advantage</h3>
              <div className="features-text-list">
                <div className="features-column">
                  <div className="feature-text-item">• Constant pressure maintenance function (Constant Pressure System)
                    <ul className="sub-list">
                      <li>Excellent piping constant pressure maintenance function (±0.3bar) extends piping life</li>
                    </ul>
                  </div>
                  <div className="feature-text-item">• Completely sealed system (Completely Sealed System)
                    <ul className="sub-list">
                      <li>Completely blocks piping water from external air to prevent air infiltration and piping corrosion</li>
                    </ul>
                  </div>
                  <div className="feature-text-item">• Minimized volume ratio (Minimized Volume Ratio)
                    <ul className="sub-list">
                      <li>Maximizes effective utilization rate of expansion tank to minimize overall tank size</li>
                    </ul>
                  </div>
                </div>
                <div className="features-column">
                  <div className="feature-text-item">• Perfect automatic control with dialogue method (Perfect Automatic Control with Dialogue Method)
                    <ul className="sub-list">
                      <li>Complete automatic control panel that even beginners can easily operate</li>
                    </ul>
                  </div>
                  <div className="feature-text-item">• Perfect quality assurance system (Reliable Quality Control System)
                    <ul className="sub-list">
                      <li>Strict quality management from design, manufacturing, inspection, delivery to construction based on ISO9001 quality certification system</li>
                      <li>Process-by-process inspection is performed by the design team and QA team at our factory</li>
                      <li>24-hour A/S system established</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            {/* Applications */}
            <div className="product-applications">
              <h3>▶ Applications - Application</h3>
              <div className="applications-text-list">
                <div className="application-text-item">- Cooling and heating systems for buildings and factories using various heat sources (district heating, boilers, heat exchangers, cooling/heating units)</div>
              </div>
            </div>

            {/* Principal Customers */}
            <div className="product-applications">
              <h3>▶ Principal Customers - Principal Customer</h3>
              <div className="partners-text-list">
                <div className="partner-text-item">- Major Tier 1 construction companies including Samsung C&T, Hyundai Construction, Hyundai Industrial Development, Daelim Industrial, Lotte Construction, Korea Land & Housing Corporation, GS Construction, Kumho Construction, Namkwang Construction, Doosan Construction, etc.</div>
              </div>
            </div>
          </section>

          {/* Expansion Separator Section */}
          <section id="expansion-separator" className="section">
            <h2 className="section-title">Expansion Separator</h2>
            
            {/* Product Overview */}
            <div className="product-description">
              <h3>Expansion Separator</h3>
              <p>Expansion separators are innovative products that simultaneously handle the roles of existing closed expansion tanks and air separators. Designed to meet the reality of high-rise buildings, they use supply pumps and electronic valves to ensure no pressure is applied to the tank, supplementing safety in the role of expansion tanks, and adding air separator functionality for easy space utilization in narrow mechanical rooms, making them future-oriented products.</p>
            </div>

            {/* Product Image */}
            <div className="esg-grid">
              <div className="esg-item">
                <img src="/products/product_08.gif" alt="Expansion Separator" className="esg-image" />
                <h3 className="esg-title">Expansion Separator</h3>
              </div>
            </div>

            {/* Advantages */}
            <div className="product-features">
              <h3>▶ Advantages - Advantage</h3>
              <div className="features-text-list">
                <div className="features-column">
                  <div className="feature-text-item">• Constant pressure maintenance function (Constant Pressure System)
                    <ul className="sub-list">
                      <li>Excellent piping constant pressure maintenance (±0.2bar) function extends piping life.</li>
                    </ul>
                  </div>
                  <div className="feature-text-item">• Removal of dissolved oxygen and chlorides in piping water
                    <ul className="sub-list">
                      <li>Prevents piping corrosion and scale formation.</li>
                    </ul>
                  </div>
                  <div className="feature-text-item">• Construction convenience (Compact)
                    <ul className="sub-list">
                      <li>Compact design makes on-site installation simple and mechanical room space utilization easy.</li>
                    </ul>
                  </div>
                </div>
                <div className="features-column">
                  <div className="feature-text-item">• Easy maintenance (Easy Maintenance)
                    <ul className="sub-list">
                      <li>All equipment is standardized and installed in one place.</li>
                    </ul>
                  </div>
                  <div className="feature-text-item">• Perfect automatic control with dialogue method
                    <ul className="sub-list">
                      <li>Fully automatic controller that even beginners can easily operate</li>
                    </ul>
                  </div>
                  <div className="feature-text-item">• Perfect quality assurance system (Reliable Quality Control System)
                    <ul className="sub-list">
                      <li>Strict quality management from design, manufacturing, inspection, delivery to commissioning based on ISO9001 quality certification system.</li>
                      <li>Process-by-process inspection is performed by the design team and QA team at our factory.</li>
                      <li>24-hour A/S system established</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            {/* Applications */}
            <div className="product-applications">
              <h3>▶ Applications - Application</h3>
              <div className="applications-text-list">
                <div className="application-text-item">Cooling and heating systems for buildings and factories using various heat sources (district heating, boilers, heat exchangers, cooling/heating units).</div>
              </div>
            </div>

            {/* Principal Customers */}
            <div className="product-applications">
              <h3>▶ Principal Customers - Principal Customer</h3>
              <div className="partners-text-list">
                <div className="partner-text-item">Major Tier 1 construction companies including Samsung Construction, Hyundai Construction, Hyundai Industrial Development, Daelim Industrial, Lotte Construction, Korea Land & Housing Corporation, GS Construction, Kumho Construction, Namkwang Construction, Doosan Construction, etc.</div>
              </div>
            </div>

          </section>

          {/* Plate Coil Section */}
          <section id="plate-coil" className="section">
            <h2 className="section-title">Plate Coil</h2>
            
            {/* Product Overview */}
            <div className="product-description">
              <h3>Plate Coil</h3>
              <p>Plate coils were developed to cover the small heat load of various chemical tanks used for heating and cooling. They can also be directly applied to reaction, cleaning, and shower tanks.</p>
            </div>

            {/* Product Image */}
            <div className="esg-grid">
              <div className="esg-item">
                <img src="/products/product_05.gif" alt="Plate Coil" className="esg-image" />
                <h3 className="esg-title">Plate Coil</h3>
              </div>
            </div>

            {/* Applications */}
            <div className="product-applications">
              <h3>▶ Applications - Application</h3>
              <div className="applications-text-list">
                <div className="application-text-item">- Cleaning, Degreasing, ED Process in Anodizing</div>
                <div className="application-text-item">- Pre-Treatment Facility in Painting, Metal Plating</div>
                <div className="application-text-item">- Decreasing, Hot Water Cleaning, Phosphorating and Various Chemical Tanks</div>
              </div>
            </div>
          </section>

          {/* Spherical Tank Section */}
          <section id="ball-tank" className="section">
            <h2 className="section-title">Spherical Tank</h2>
            
            {/* Product Overview */}
            <div className="product-description">
              <h3>Spherical Tank</h3>
              <p>Spherical tanks are mainly used for storage of volatile and high-pressure liquids such as LPG, LNG, ammonia, and butane. Due to their spherical structure, they have the advantage of evenly distributing internal pressure. They are designed together with steel support structures and are manufactured in various sizes for different purposes according to design pressure and temperature.</p>
            </div>

            {/* Product Images */}
            <div className="ball-tank-slider" style={{display: 'flex', gap: '20px', marginBottom: '30px', justifyContent: 'center', overflow: 'hidden', position: 'relative'}}>
              <div className="slider-container" style={{display: 'flex', transition: 'transform 0.5s ease-in-out', width: '100%'}}>
                <img src="/products/balltank1.jpg" alt="Spherical Tank" style={{maxHeight: '300px', flex: '1', minWidth: '100%'}} />
                <img src="/products/balltank2.jpg" alt="Spherical Tank Structure" style={{maxHeight: '300px', flex: '1', minWidth: '100%'}} />
              </div>
              <button className="slider-prev" style={{position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', background: 'rgba(0,0,0,0.5)', color: 'white', border: 'none', padding: '10px', borderRadius: '50%', cursor: 'pointer', zIndex: 2}} onClick={() => {
                const container = document.querySelector('.ball-tank-slider .slider-container');
                const currentTransform = container.style.transform || 'translateX(0%)';
                if (currentTransform === 'translateX(-100%)') {
                  container.style.transform = 'translateX(0%)';
                } else {
                  container.style.transform = 'translateX(-100%)';
                }
              }}>‹</button>
              <button className="slider-next" style={{position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)', background: 'rgba(0,0,0,0.5)', color: 'white', border: 'none', padding: '10px', borderRadius: '50%', cursor: 'pointer', zIndex: 2}} onClick={() => {
                const container = document.querySelector('.ball-tank-slider .slider-container');
                const currentTransform = container.style.transform || 'translateX(0%)';
                if (currentTransform === 'translateX(0%)') {
                  container.style.transform = 'translateX(-100%)';
                } else {
                  container.style.transform = 'translateX(0%)';
                }
              }}>›</button>
            </div>

            {/* Advantages */}
            <div className="product-features">
              <h3>▶ Advantages - Advantage</h3>
              <div className="features-text-list">
                <div className="features-column">
                  <div className="feature-text-item">• Structure advantageous for pressure distribution (Pressure Distribution Structure)</div>
                  <div className="feature-text-item">• Advantageous for safety assurance (Safety Assurance)</div>
                  <div className="feature-text-item">• Excellent space utilization efficiency (Space Efficiency)</div>
                </div>
                <div className="features-column">
                  <div className="feature-text-item">• Easy maintenance (Easy Maintenance)</div>
                  <div className="feature-text-item">• Various capacity and application support (Various Capacity & Applications)</div>
                </div>
              </div>
            </div>
          </section>

          {/* ATM Tank Section */}
          <section id="atm-tank" className="section">
            <h2 className="section-title">ATM Tank</h2>
            
            {/* Product Overview */}
            <div className="product-description">
              <h3>ATM Tank</h3>
              <p>ATM tanks are mainly used as tanks for large-capacity storage of crude oil, refined oil, chemical products, etc. in power plants, chemical factories, and storage terminals. They are used under atmospheric pressure or low-pressure conditions and are manufactured in structures such as floating roof, dome roof, and cone roof according to their purpose.</p>
            </div>

            {/* Product Images */}
            <div className="atm-tank-slider" style={{display: 'flex', gap: '20px', marginBottom: '30px', justifyContent: 'center', overflow: 'hidden', position: 'relative'}}>
              <div className="slider-container" style={{display: 'flex', transition: 'transform 0.5s ease-in-out', width: '100%'}}>
                <img src="/products/ATM1.jpg" alt="ATM Tank" style={{maxHeight: '300px', flex: '1', minWidth: '100%'}} />
                <img src="/products/ATM2.jpg" alt="ATM Tank Structure" style={{maxHeight: '300px', flex: '1', minWidth: '100%'}} />
                <img src="/products/ATM3.jpg" alt="ATM Tank Installation" style={{maxHeight: '300px', flex: '1', minWidth: '100%'}} />
              </div>
              <button className="slider-prev" style={{position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', background: 'rgba(0,0,0,0.5)', color: 'white', border: 'none', padding: '10px', borderRadius: '50%', cursor: 'pointer', zIndex: 2}} onClick={() => {
                const container = document.querySelector('.atm-tank-slider .slider-container');
                const currentTransform = container.style.transform || 'translateX(0%)';
                if (currentTransform === 'translateX(0%)') {
                  container.style.transform = 'translateX(-200%)';
                } else if (currentTransform === 'translateX(-100%)') {
                  container.style.transform = 'translateX(0%)';
                } else {
                  container.style.transform = 'translateX(-100%)';
                }
              }}>‹</button>
              <button className="slider-next" style={{position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)', background: 'rgba(0,0,0,0.5)', color: 'white', border: 'none', padding: '10px', borderRadius: '50%', cursor: 'pointer', zIndex: 2}} onClick={() => {
                const container = document.querySelector('.atm-tank-slider .slider-container');
                const currentTransform = container.style.transform || 'translateX(0%)';
                if (currentTransform === 'translateX(0%)') {
                  container.style.transform = 'translateX(-100%)';
                } else if (currentTransform === 'translateX(-100%)') {
                  container.style.transform = 'translateX(-200%)';
                } else {
                  container.style.transform = 'translateX(0%)';
                }
              }}>›</button>
            </div>

            {/* Advantages */}
            <div className="product-features">
              <h3>▶ Advantages - Advantage</h3>
              <div className="features-text-list">
                <div className="features-column">
                  <div className="feature-text-item">• Large capacity storage possible (Large Capacity Storage)</div>
                  <div className="feature-text-item">• Various liquid storage possible (Wide Range of Fluids)</div>
                  <div className="feature-text-item">• Structural reliability secured (Reliable Structural Design)</div>
                </div>
                <div className="features-column">
                  <div className="feature-text-item">• Easy construction and maintenance management (Ease of Construction and Maintenance)</div>
                  <div className="feature-text-item">• International standard design application such as API 650 (Compliance with API Standards)</div>
                </div>
              </div>
            </div>
          </section>

        </div>
      </div>
    </>
  );
};

export default Products;